import { NATURE_PERTURBATION } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case NATURE_PERTURBATION.ANTENNE_EN_PANNE:
        return 'Antenne en panne';
      case NATURE_PERTURBATION.SIGNAL_ABSENT_OU_FAIBLE:
        return 'Signal TNT absent ou faible';
      case NATURE_PERTURBATION.PROBLEME_PREAMPLI:
        return 'Problème de préampli/amplificateur';
      case NATURE_PERTURBATION.BROUILLAGE_4G_5G:
        return 'Brouillage 4G/5G';
      case NATURE_PERTURBATION.PROBLEME_DIFFUSION:
        return 'Diffusion (défaut de l\'émetteur)';
      case NATURE_PERTURBATION.AUTRE:
        return 'Autre';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/nature-perturbation.filter.js